import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PillarCantonEditingDialog from '../DialogEditingType/PillarCantonEditingDialog';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';
import { PILLAR, PILLAR_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import { fetchPillarConnectionCount } from '../CountFile/ConnectionCount';

const PillarCantonDialog = ({open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, role, user, cantonRefresh,
  groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, setIsComponentСhangeCoor}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [connectionCount, setConnectionCount] = useState(0);

   useEffect(() => {
      const updateConnectionCount = async () => {  
        const count = await fetchPillarConnectionCount(content.id);
        if (count !== null) {
          setConnectionCount(count); 
        }
      };
      updateConnectionCount();
    });
 
  const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
      setOpenModalDescription(true);
    }  
  }; 

  const openModalEditingContent = () => {
     setOpenModalEditing(true);
  };      

  return (
    <Dialog open={open} className="dialogStyle">
    <DialogContent>
    <img src='./pillar.png' width='30' height='30' style={{ marginRight: "5px" }}/>
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #0c0c0cff'}}>Опора</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #1a1a1aff' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "опора"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #0e0e0eff' }}>{content.city}</span> </label>
       <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/>  
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #141414ff' }}>{content.ownerPillarName}</span> </label>
      <br/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Тариф/км: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.ownerPillarPrice} грн.</span> </label> */}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <label style={{ color: '#292929', fontWeight: 'bold', marginRight: '5px' }}>
          Координаты:
        </label>
        <div>
          <div style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px #1d1d1dff' }}>
            {content.latitude}
          </div>
          <div style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px #1b1b1bff' }}>
            {content.longitude}
          </div>
        </div>    
         <Button 
            style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
            onClick={() => { copyToClipboard(`${content.latitude},${content.longitude} `, "Координаты"); }}>
            <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      </div>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #111111ff' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #131313ff' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #161616ff' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #1a1a1aff'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
      </button>

      <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
     {((user === content.authorId && (role.role === ROLE_ENGINNER || role.role === ROLE_MASTER )) || role.role === ROLE_ADMIN) && (
    // {user === content.authorId && (role.role === ROLE_ADMIN || role.role === ROLE_ENGINNER) && (
        <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

    {/* Snackbar */}
    <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={6000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={PILLAR}
          flag={PILLAR_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

      {/* Modal редактирование PillarCanton*/}
      <PillarCantonEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        cantonRefresh={cantonRefresh}
        setIsComponentСhangeCoor={setIsComponentСhangeCoor}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        user={user}
      />    
   </Dialog>
  );
}

export default PillarCantonDialog;